import React from "react"
import { Combobox, ComboboxOption } from "@/components/ui/combobox"

interface CompanyFilterProps {
  options: string[]
  value: string[]
  onChange: (values: string[]) => void
  placeholder?: string
  className?: string
}

function CompanyFilter({
                         options,
                         value,
                         onChange,
                         placeholder = "Tous les clients",
                         className = "",
                       }: CompanyFilterProps) {
  const comboboxOptions: ComboboxOption[] = options.map((opt) => ({
    value: opt,
    label: opt,
  }))

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="text-sm text-gray-500 shrink-0">Filtrer par clients :</span>
      <Combobox
        options={comboboxOptions}
        mode="multiple"
        value={value}
        onChange={(val) => onChange(val as string[])}
        placeholder={placeholder}
        searchPlaceholder="Rechercher un client..."
        emptyMessage="Aucun client trouvé."
        className="min-w-[220px] max-w-sm"
      />
    </div>
  )
}

export default CompanyFilter